export default {
    title: "O-I",
    support: "支持",
    dashboard: "仪表板"
}